import type { Meta, StoryFn } from '@storybook/react';
import type { FeedbackBoxProps } from './FeedbackBox';

import { FeedbackBox } from './FeedbackBox';

import { Container } from 'storyComponents/Container';
import { Repeater } from 'components/Repeater';

const codeString = '<FeedbackBox id={id} level={level} feedback={feedback} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/FeedbackBox',
  component: FeedbackBox,
  parameters: {
    inspectComponent: FeedbackBox,
    codeString,
  },
} as Meta<FeedbackBoxProps>;

const Template: StoryFn<FeedbackBoxProps> = (args) => (
  <Container>
    <FeedbackBox {...args} />
  </Container>
);

export const FeedbackBoxExample = Template.bind({});
FeedbackBoxExample.args = {
  id: 'gba0d2d4',
  level: 'success',
  feedback: 'Example FeedbackBox text',
};

export const WithElementFeedback = Template.bind({});
WithElementFeedback.args = {
  id: 'gba0d2d4',
  level: 'success',
  feedback: (
    <Repeater>
      <h2>FeedbackElement</h2>
      <ul>
        <li>Feedback 1</li>
        <li>Feedback 2</li>
        <li>Feedback 3</li>
      </ul>
    </Repeater>
  ),
};
